<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
    import Vue from 'vue';
    //引入elementui
    import ElementUI from 'element-ui'
    import { Loading } from 'element-ui'
    //样式需要单独引入
    import 'element-ui/lib/theme-chalk/index.css'
    //挂载
    Vue.use(ElementUI);

    Vue.prototype.openLoading = function() {
      const loading = this.$loading({           // 声明一个loading对象
        lock: true,                             // 是否锁屏
        text: '正在加载...',                     // 加载动画的文字
        spinner: 'el-icon-loading',             // 引入的loading图标
        background: 'rgba(0, 0, 0, 0.3)',       // 背景颜色
        target: '.sub-main',                    // 需要遮罩的区域
        body: true,
        customClass: 'mask'                     // 遮罩层新增类名
      })
      setTimeout(function () {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
        loading.close();                        // 关闭遮罩层
      },3000)
      return loading;
    }

    export default {
        name: 'App',
        provide (){
            return {
                reload:this.reload
            }
        },
        data(){
            return {
                isRouterAlive:true
            }
        },
        methods:{
            reload (){
                this.isRouterAlive = false
                this.$nextTick(function(){
                    this.isRouterAlive = true
                })
            }
        }
    }
</script>

<style>
.row{
  display: flex;
  flex-direction: row;
}
.column{
  display: flex;
  flex-direction: column;
}
.flex-center{
  justify-content: center;
  align-items: center;
}
.mask{
  z-index:9999 !important;
}
.el-loading-spinner .el-loading-text{
  font-size:1.6rem;
}
.el-loading-spinner i{
  font-size:3rem;
}
</style>
